import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import P1PrescriptionCancel from './P1PrescriptionCancel';
import { EReceptRow } from '../../../../Components/eRecept/List/EReceptListItem';

interface Props extends BaseModalProps {
	item: EReceptRow;
	onSuccess: () => void;
}

const P1PrescriptionCancelModal: React.FC<Props> = props => {
	return (
		<BaseModal {...props} title='component.p1PrescriptionCancel.modalTitle'>
			<P1PrescriptionCancel item={props.item} onSuccess={props.onSuccess} />
		</BaseModal>
	);
};

export default P1PrescriptionCancelModal;
